export enum RegistrationStatus {
  InProgress = 1,
  ClientCompleted = 2,
  ClientResponseNeeded = 3,
  Validated = 4,
  Active = 5,
}
